angular
    .module('webcomm')
    .controller(
        "LoginController",
        [   '$scope', '$location', '$log', 'connectionService', 'wtcpjsService', 'rememberMeService', 'authService',
            function ($scope, $location, $log, connectionService, wtcpjsService, rememberMeService, authService) {

    $log.info('LoginController initialized - logging out');
    $scope.$applyAsync(function($scope) {
        $scope.initialLoad = true;
    });

    connectionService.logout();
    wtcpjsService.subscribeToEvents();

    // remembered? load
    $scope.loginInfo = rememberMeService.isRemembered() ? {
        rememberMe: true,
        name: rememberMeService.get().user,
        server: rememberMeService.get().server,
    } : {
        server: $location.host()
    };

    $scope.status = {
        appVersion: window.webcomm_version,
        error: connectionService.getAndResetLogoutError(),
        isSigningIn: false,
        isProfileVisible: false
    };

    $scope.loginPage = function () {
        $log.debug("Back To main Page");
        //connectionService.logout();
        window.location.reload(true);
    };

    $scope.loginReset = function() {
        $scope.status.error = false;
        connectionService.logout();
    };

    $scope.populateLoginInfo = function (info) {
        $scope.loginInfo = info;
        $scope.loginInfo.profile = '';
    };

    $scope.populateLoginInfoAndLogin = function (info) {
        $scope.populateLoginInfo(info);
        $scope.login();
    };

    $scope.cloud = {
        status: 'pending'
    };

    authService.getAuthUrl()
        .then((data) => {
            if (data) {
                $scope.cloud = {
                    server: data,
                    status: 'ready'
                };
            } else {
                $scope.cloud.server = null;
                $scope.cloud.status = 'ready';
            }
        })
        .catch((err) => {
            showError(err.message);
        })

    function showError(error) {
        $scope.status.isProfileVisible = false;
        $scope.status.isSigningIn = false;
        $scope.status.error = error;
    }

    function showProfile() {
        $scope.status.isProfileVisible = true;

        // default to the first one
        $scope.profiles.selected = $scope.profiles.available[0];
        if (rememberMeService.isRemembered()) {
            let savedProfile = rememberMeService.get().profile;
            // ..or change to saved one if it matches our set
            if (savedProfile && $scope.profiles.available.some(p => p.profileId === savedProfile.profileId)) {
                $scope.profiles.selected = savedProfile;
            }
        }
    }

    $scope.login = function () {
        $log.debug("loginController.login");
        $scope.status.isSigningIn = true;
        $scope.status.error = false;

        let username = $scope.loginInfo.name,
            password = $scope.loginInfo.password,
            server = $scope.loginInfo.server;

        if ($scope.cloud.server)
        {
            // call to provisioning server with username and password
            // get back the UserID and Access Token,
            // log in with those.
            authService
                .getToken($scope.cloud.server, $scope.loginInfo.name, $scope.loginInfo.password)
                .then(token => {
                    $log.debug("got provisioning token", token);

                    if (token.isSuccess) {
                        username = token.userId;
                        password = token.accessToken;
                        server = token.url;

                        $log.debug(`logging into ${server} with username ${username} and password ${password}`);
                        login(server, username, password);
                    }
                    else {
                        showError(token.errorMessage);
                    }
                })
                .catch(err => {
                    showError(err.message);
                });
        }
        else {
            login(server, username, password);
        }
    };

    function setProfiles(profiles) {
        $log.debug("login success. Profiles: ", profiles);
        $scope.status.error = false;
        $scope.profiles = {
            available: profiles,
            selected: profiles[0] // select the first one
        };
    }

    function login(server, username, password) {
        connectionService.login(server, username, password)
            .then(
                function (profiles) { // success
                    setProfiles(profiles);

                    // if there's only one profile, skip profile selection step.
                    if (profiles.length === 1) {
                        $log.debug("single profile found - logging in");
                        $scope.selectProfile(username, password);
                    } else {
                        showProfile();
                    }
                },
                function (err) { // error
                    $log.warn("loginController login: ", err);
                    showError(err);
                    //   $scope.status.isSigningIn = false;
                }
            )
            .finally(() => $scope.status.isSigningIn = false);
    };

    $scope.selectProfile = function (username, password) {
        if (!username) {
            username = $scope.loginInfo.name;
            password = $scope.loginInfo.password;
        }

        $log.debug("loginController.selectProfile");

        if ($scope.profiles == undefined) {
            throw Error("No profiles defined"); // this should be handled with a message
        }

        if ($scope.loginInfo.rememberMe) {
            rememberMeService.remember($scope.loginInfo.name, $scope.loginInfo.server, $scope.profiles.selected);
        } else {
            rememberMeService.forget();
        }

        connectionService.setProfile(
                username,
                password,
                $scope.profiles.selected
            )
            .then(() => $location.path('/main' + authService.authUrlPath))
            .catch(err => showError(err));
    }

    var logoutError = $scope.$on('logoutError', function (event, error) {
        $scope.status.error = error;
        $log.info('logged out - ' + error);
    });

    var unbindSelectNewProfile = $scope.$on('connectionService.selectNewProfile', (e, profiles) => {
        setProfiles(profiles);
        showProfile();
    });

    $scope.$on('destroy', function() {
        logoutError();
        unbindSelectNewProfile();
    });


}]);